import React, {Component} from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Preloader from '../../../components/preloader';
import EmptyState from '../../../components/empty-state-container';

const TYPES = ['tables', 'views', 'procedures', 'triggers'];

class ObjectPickerTree extends Component {
  constructor(props) {
    super(props);
    this.state = {expanded: {tables: true, views: false, procedures: false, triggers: false}};
  }

  toggleSection = (type) => {
    // eslint-disable-next-line security/detect-object-injection -- type is from TYPES constant array, not user input
    this.setState((prev) => ({expanded: {...prev.expanded, [type]: !prev.expanded[type]}}));
  };

  render() {
    const {
      objectList, mode, selectedObjects, onModeChange, onToggleObject,
      onSelectAllByType, onDeselectAllByType, searchQuery, onSearchChange, loading, onLoadObjects,
    } = this.props;
    const {expanded} = this.state;
    const selected = selectedObjects || [];

    if (loading) return <Preloader loading />;

    return (
      <div className="sc-object-picker">
        <RadioGroup row value={mode} onChange={(e) => onModeChange(e.target.value)}>
          <FormControlLabel
            value="all"
            control={<Radio inputProps={{'data-testid': 'sc-picker-mode-all'}} />}
            label="All objects"
          />
          <FormControlLabel
            value="selected"
            control={<Radio inputProps={{'data-testid': 'sc-picker-mode-selected'}} />}
            label="Selected objects"
          />
        </RadioGroup>

        {mode === 'selected' && !objectList && (
          <Button variant="outlined" onClick={onLoadObjects}>Load objects</Button>
        )}

        {mode === 'selected' && objectList && (
          <div>
            <TextField
              placeholder="Search objects…"
              value={searchQuery || ''}
              onChange={(e) => onSearchChange(e.target.value)}
              fullWidth
              size="small"
              inputProps={{'data-testid': 'sc-object-search'}}
            />
            <div className="sc-selected-count">{selected.length} selected</div>
            {TYPES.map((type) => {
              // eslint-disable-next-line security/detect-object-injection -- type is from TYPES constant array
              const items = (objectList[type] || []).filter((name) =>
                !searchQuery || name.toLowerCase().includes(searchQuery.toLowerCase()),
              );
              if (items.length === 0) return null;
              // eslint-disable-next-line security/detect-object-injection -- type is from TYPES constant array
              const isExpanded = expanded[type];
              return (
                <div key={type} className="sc-picker-section">
                  <div
                    className="sc-picker-section-header"
                    onClick={() => this.toggleSection(type)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') this.toggleSection(type);
                    }}
                  >
                    <span className="sc-picker-section-title">
                      {type.charAt(0).toUpperCase() + type.slice(1)} ({items.length})
                    </span>
                    <span className="sc-picker-section-actions">
                      <Button
                        size="small"
                        data-testid={`sc-selectall-${type}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          onSelectAllByType(type, items);
                        }}
                      >
                        Select all
                      </Button>
                      <Button
                        size="small"
                        data-testid={`sc-deselectall-${type}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          onDeselectAllByType(type, items);
                        }}
                      >
                        Deselect all
                      </Button>
                    </span>
                  </div>
                  {isExpanded && (
                    <div className="sc-picker-items">
                      {items.map((name) => (
                        <FormControlLabel
                          key={name}
                          className="sc-picker-item"
                          label={name}
                          control={
                            <Checkbox
                              checked={selected.includes(name)}
                              onChange={() => onToggleObject(name)}
                              inputProps={{'data-testid': `sc-object-checkbox-${name}`}}
                            />
                          }
                        />
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {mode === 'selected' && objectList && selected.length === 0 && (
          <EmptyState message="No objects selected" />
        )}
      </div>
    );
  }
}

export default ObjectPickerTree;
